import React from "react";
import Navbar from "../components/navbar";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import ServicesImg from "../assets/af7.jpg";
import { Card, Button } from 'react-bootstrap'; // Import React Bootstrap components for card and button

const services = [
    {
        title: "Loan Application",
        content: [
            "Eligibility Criteria: Members must meet specific eligibility criteria, which can include a minimum period of membership, regular saving patterns, and a satisfactory credit history within the SACCO.",
            "Loan Application Form: Eligible members complete a loan application form, providing details such as the loan amount, purpose of the loan, repayment period, and any required collateral or guarantors."
        ]
    },
];

function Services() {
    const handleLoanButtonClick = () => {
        // Redirect to M-Pesa or handle the button click as needed
        window.location.href = "https://mpesa-link.example.com"; // Replace with your M-Pesa link
    };

    return (
        <React.Fragment>
            <Navbar />
            <Hero 
                cName="hero-mid"
                heroImg={ServicesImg}
                title="Our Services"
                services={services} // Pass services content to Hero component
            />
            <div className="container mt-4">
                {services.map((service, index) => (
                    <Card key={index} className="mb-3" style={{
                        position: 'relative',
                        zIndex: 2,
                        background: 'white',
                        padding: '20px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        marginBottom: '20px'
                    }}>
                        <Card.Body>
                            <Card.Title style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{service.title}</Card.Title>
                            <Card.Text>
                                {service.content.map((text, i) => (
                                    <p key={i} style={{ fontWeight: 'bold', margin: '10px 0' }}>{text}</p>
                                ))}
                            </Card.Text>
                            <Button 
                                variant="success" // Change button variant to green
                                onClick={handleLoanButtonClick} 
                                style={{
                                    marginTop: '10px',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    border: 'none',
                                    transition: 'background-color 0.3s ease'
                                }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#4CAF50'}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#28a745'}
                            >
                                Apply for Loan
                            </Button>
                        </Card.Body>
                    </Card>
                ))}
            </div>
            <Footer />
        </React.Fragment>
    );
}

export default Services;
